const InfluencerListNewBaseElement =
  typeof CustomHTMLElement !== 'undefined' ? CustomHTMLElement : HTMLElement;

function syncInfluencerListNewPrevNext(section) {
  const globalWidth = section.querySelector('.global-list__width');
  const sliderList = section.querySelector('.global-list-item__width') || globalWidth;
  const cards = sliderList ? Array.from(sliderList.children) : [];
  const firstCard = cards[0];
  const listStyle = sliderList ? window.getComputedStyle(sliderList) : null;
  const gapValue = listStyle ? parseFloat(listStyle.gap) || 0 : 0;
  const cardWidth = firstCard ? firstCard.offsetWidth : 0;
  const scrollWidth = globalWidth ? globalWidth.scrollWidth : 0;
  const clientWidth = globalWidth ? globalWidth.clientWidth : 0;
  const hasHorizontalScroll = scrollWidth > clientWidth;

  if (typeof globalScrollPrevNext === 'function') {
    globalScrollPrevNext(section);
    return;
  }

  if (!globalWidth) {
    return;
  }

  let scrollLeftBtn = section.querySelector('.global_scroll_arrow_left');
  let scrollRightBtn = section.querySelector('.global_scroll_arrow_right');

  if (cards.length === 0 || !scrollLeftBtn || !scrollRightBtn) {
    return;
  }

  const listPaddingLeft = parseFloat(listStyle.paddingLeft) || 0;
  const totalCardWidth = cardWidth + gapValue;
  const visibleWidth = globalWidth.clientWidth;
  const contentVisibleWidth = visibleWidth - listPaddingLeft;
  let fullVisibleCount = Math.floor(contentVisibleWidth / totalCardWidth);

  fullVisibleCount = Math.max(1, fullVisibleCount);

  const scrollDistance = totalCardWidth * fullVisibleCount;

  if (hasHorizontalScroll) {
    scrollRightBtn.disabled = false;
    scrollLeftBtn.disabled = true;
  } else {
    scrollLeftBtn.disabled = true;
    scrollRightBtn.disabled = true;
  }

  const newLeftBtn = scrollLeftBtn.cloneNode(true);
  const newRightBtn = scrollRightBtn.cloneNode(true);

  scrollLeftBtn.parentNode.replaceChild(newLeftBtn, scrollLeftBtn);
  scrollRightBtn.parentNode.replaceChild(newRightBtn, scrollRightBtn);

  scrollLeftBtn = section.querySelector('.global_scroll_arrow_left');
  scrollRightBtn = section.querySelector('.global_scroll_arrow_right');

  scrollLeftBtn.addEventListener('click', () => {
    globalWidth.scrollBy({ left: `-${scrollDistance}`, behavior: 'smooth' });
  });

  scrollRightBtn.addEventListener('click', () => {
    globalWidth.scrollBy({ left: scrollDistance, behavior: 'smooth' });
  });

  const updateArrowState = () => {
    const scrollLeft = globalWidth.scrollLeft;
    const currentClientWidth = globalWidth.clientWidth;

    if (scrollLeft <= 0) {
      scrollLeftBtn.disabled = true;
      scrollRightBtn.disabled = false;
    } else if (globalWidth.scrollWidth - (currentClientWidth + scrollLeft) <= 2) {
      scrollLeftBtn.disabled = false;
      scrollRightBtn.disabled = true;
    } else {
      scrollLeftBtn.disabled = false;
      scrollRightBtn.disabled = false;
    }
  };

  if (globalWidth._ffInfluencerListNewScrollHandler) {
    globalWidth.removeEventListener('scroll', globalWidth._ffInfluencerListNewScrollHandler);
  }

  globalWidth._ffInfluencerListNewScrollHandler = updateArrowState;
  globalWidth.addEventListener('scroll', updateArrowState);
  updateArrowState();
}

function openInfluencerListNewVideo(trigger) {
  const root = trigger.closest('influencer-list-new');
  if (!root) {
    return;
  }

  if (typeof root.isShowMainVideo === 'function') {
    root.isShowMainVideo(trigger);
    return;
  }

  const fixedBox = root.querySelector('.mian_video_boxs_fixed');
  if (fixedBox) {
    fixedBox.style.display = 'block';
  }

  document.documentElement.classList.toggle('lock-all', true);

  const swiperBox = root.querySelector('.swiper-container');
  const slideElements = root.querySelectorAll('.swiper-slide');
  const totalSlides = slideElements.length;
  let initialIndex = parseInt(trigger.getAttribute('data-index'), 10) || 0;

  initialIndex = Math.min(Math.max(initialIndex, 0), Math.max(totalSlides - 1, 0));

  const videoPayList = Array.from(root.querySelectorAll('.tiktok-video')) || [];
  if (initialIndex === 0 && videoPayList[0]) {
    videoPayList[0].play().catch(() => {});
  }

  if (swiperBox) {
    new Swiper(`#${swiperBox.id}`, {
      direction: 'vertical',
      mousewheel: true,
      keyboard: true,
      simulateTouch: true,
      resistanceRatio: 0,
      initialSlide: initialIndex,
      speed: 500,
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, '-100%', 0],
        },
        next: {
          translate: [0, '100%', 0],
        },
      },
      on: {
        slideChange: function () {
          const currentSlide = this.slides[this.activeIndex];
          const prevSlide = this.slides[this.previousIndex];
          const prevVideo = prevSlide?.querySelector('video');
          if (prevVideo) {
            prevVideo.pause();
          }

          const currentVideo = currentSlide?.querySelector('video');
          if (currentVideo) {
            currentVideo.currentTime = 0;
            currentVideo.play().catch(() => {});
          }
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

function closeInfluencerListNewVideo(root) {
  if (!root) {
    return;
  }

  if (typeof root.isHiddenMainVideo === 'function') {
    root.isHiddenMainVideo();
    return;
  }

  const fixedBox = root.querySelector('.mian_video_boxs_fixed');
  const videoPayList = Array.from(root.querySelectorAll('.tiktok-video')) || [];

  videoPayList.forEach((video) => {
    video.pause();
  });

  if (fixedBox) {
    fixedBox.style.display = 'none';
  }

  document.documentElement.classList.toggle('lock-all', false);
}

window.openInfluencerListNewVideo = openInfluencerListNewVideo;

if (!window.__ffInfluencerListNewDelegatedClickBound) {
  window.__ffInfluencerListNewDelegatedClickBound = true;
  document.addEventListener('click', (event) => {
    const tagButton = event.target.closest('influencer-list-new .influencer_tags');
    if (tagButton) {
      event.stopPropagation();
      return;
    }

    const arrowButton = event.target.closest('influencer-list-new .global_scroll_arrow');
    if (arrowButton) {
      event.stopPropagation();
      return;
    }

    const trigger = event.target.closest('influencer-list-new .influencer_video_li');
    if (!trigger) {
      const closeTrigger = event.target.closest('influencer-list-new .mian__box_close');
      if (closeTrigger) {
        const root = closeTrigger.closest('influencer-list-new');
        closeInfluencerListNewVideo(root);
        return;
      }

      const fixedBox = event.target.closest('influencer-list-new .mian_video_boxs_fixed');
      if (!fixedBox) {
        return;
      }

      if (event.target.closest('.tiktok-video_hidden')) {
        return;
      }

      const root = fixedBox.closest('influencer-list-new');
      closeInfluencerListNewVideo(root);
      return;
    }

    openInfluencerListNewVideo(trigger);
  });
}

function initializeInfluencerListNewInstance(instance) {
  if (!instance || instance.dataset.ffInfluencerListNewInitialized === 'true') {
    return;
  }

  instance.dataset.ffInfluencerListNewInitialized = 'true';

  let box = instance.querySelector('.product-variants_list-scroll');
  if (box) {
    const syncPrevNext = () => syncInfluencerListNewPrevNext(instance);

    syncPrevNext();
    requestAnimationFrame(syncPrevNext);
    setTimeout(syncPrevNext, 300);
    window.addEventListener('load', syncPrevNext, { once: true });

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncPrevNext, 500);
    });

    const mediaNodes = Array.from(
      instance.querySelectorAll('.influencer_video_li video, .influencer_video_li img'),
    );

    mediaNodes.forEach((media) => {
      if (media.tagName === 'VIDEO') {
        media.addEventListener('loadedmetadata', syncPrevNext, { once: true });
        media.addEventListener('loadeddata', syncPrevNext, { once: true });
      } else {
        media.addEventListener('load', syncPrevNext, { once: true });
      }
    });

    if (typeof ResizeObserver !== 'undefined' && !instance._ffInfluencerListNewResizeObserver) {
      instance._ffInfluencerListNewResizeObserver = new ResizeObserver(() => {
        syncPrevNext();
      });

      instance._ffInfluencerListNewResizeObserver.observe(box);

      const globalWidth = instance.querySelector('.global-list__width');
      if (globalWidth && globalWidth !== box) {
        instance._ffInfluencerListNewResizeObserver.observe(globalWidth);
      }

      const firstCard = instance.querySelector('.influencer_li');
      if (firstCard) {
        instance._ffInfluencerListNewResizeObserver.observe(firstCard);
      }
    }
  }

  let videoInit = Array.from(instance.querySelectorAll('.influencer_video_li')) || [];
  videoInit.forEach((item) => {
    item.addEventListener('click', () => {
      instance.isShowMainVideo(item);
    });
    item.addEventListener('mouseenter', () => {
      instance.startFragmentHoverTimer(item);
    });
    item.addEventListener('mouseleave', () => {
      instance.clearFragmentHoverTimer();
    });
  });

  const influencerTags = Array.from(instance.querySelectorAll('.influencer_tags')) || [];
  influencerTags.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  const prevNextArrows = Array.from(instance.querySelectorAll('.global_scroll_arrow')) || [];
  prevNextArrows.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation();
    });
  });

  const influencerUl = instance.querySelector('.influencer_ul');
  if (influencerUl) {
    instance.showPlayFragmentVideo(influencerUl);
  }

  instance.fixed_boxs = instance.querySelector('.mian_video_boxs_fixed');
  if (instance.fixed_boxs) {
    instance.fixed_boxs.addEventListener('click', (e) => {
      const isInsideTikTokVideo = e.target.closest('.tiktok-video_hidden');
      if (!isInsideTikTokVideo) {
        instance.isHiddenMainVideo();
      }
    });
  }
}

var influencerListNew = class extends InfluencerListNewBaseElement {
  connectedCallback() {
    initializeInfluencerListNewInstance(this);
  }

  disconnectedCallback() {
    this.clearFragmentHoverTimer();
    this.stopFragmentPreviewVideo();

    if (this._fragmentVisibilityObserver) {
      this._fragmentVisibilityObserver.disconnect();
      this._fragmentVisibilityObserver = null;
    }

    if (this._ffInfluencerListNewResizeObserver) {
      this._ffInfluencerListNewResizeObserver.disconnect();
      this._ffInfluencerListNewResizeObserver = null;
    }

    if (typeof super.disconnectedCallback === 'function') {
      super.disconnectedCallback();
    }
  }

  showPlayFragmentVideo(influencerUl) {
    let videoPayList = Array.from(this.querySelectorAll('.influencer_video_li video')) || [];
    videoPayList.forEach((video, index) => {
      video.muted = true;
      video.playsInline = true;
      if (video.dataset.fragmentEndedBound === 'true') {
        return;
      }

      video.dataset.fragmentEndedBound = 'true';
      video.addEventListener('ended', () => {
        if (index === 0) {
          this._hasAutoPlayedFirstFragmentVideo = true;
        }

        if (this._currentFragmentPreviewVideo === video) {
          this._currentFragmentPreviewVideo = null;
        }
      });
    });

    if (videoPayList.length === 0) {
      return false;
    }

    const firstVideo = videoPayList[0];
    if (!firstVideo) {
      return false;
    }

    if (this._fragmentVisibilityObserver) {
      this._fragmentVisibilityObserver.disconnect();
    }

    this._fragmentVisibilityObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (!entry) {
        return;
      }

      if (entry.isIntersecting) {
        if (!this._hasAutoPlayedFirstFragmentVideo) {
          this.playFragmentPreviewVideo(firstVideo);
        }
      } else {
        this.clearFragmentHoverTimer();
        this.stopFragmentPreviewVideo();
      }
    }, { threshold: 0.1 });

    this._fragmentVisibilityObserver.observe(influencerUl);
  }

  clearFragmentHoverTimer() {
    if (this._fragmentHoverTimer) {
      clearTimeout(this._fragmentHoverTimer);
      this._fragmentHoverTimer = null;
    }

    this._hoverPreviewItem = null;
  }

  stopFragmentPreviewVideo() {
    const currentVideo = this._currentFragmentPreviewVideo;
    if (!currentVideo) {
      return;
    }

    currentVideo.pause();
    currentVideo.currentTime = 0;

    this._currentFragmentPreviewVideo = null;
  }

  playFragmentPreviewVideo(video) {
    if (!video) {
      return;
    }

    if (this._currentFragmentPreviewVideo && this._currentFragmentPreviewVideo !== video) {
      this.stopFragmentPreviewVideo();
    }

    this._currentFragmentPreviewVideo = video;
    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch((error) => {
        if (error?.name === 'AbortError') {
          return;
        }

        console.log('Play failed:', error);
      });
    }
  }

  startFragmentHoverTimer(item) {
    if (!item) {
      return;
    }

    this.clearFragmentHoverTimer();
    this._hoverPreviewItem = item;
    this._fragmentHoverTimer = setTimeout(() => {
      if (this._hoverPreviewItem !== item) {
        return;
      }

      const currentVideo = item.querySelector('video');
      if (!currentVideo) {
        return;
      }

      this.stopFragmentPreviewVideo();
      currentVideo.currentTime = 0;
      this.playFragmentPreviewVideo(currentVideo);
      this._fragmentHoverTimer = null;
    }, 500);
  }

  isHiddenMainVideo() {
    let videoPayList = Array.from(this.querySelectorAll('.tiktok-video')) || [];
    videoPayList.forEach((video) => {
      video.pause();
    });

    if (this.fixed_boxs) {
      this.fixed_boxs.style.display = 'none';
    }

    document.documentElement.classList.toggle('lock-all', false);
  }

  isShowMainVideo(item) {
    if (this.fixed_boxs) {
      this.fixed_boxs.style.display = 'block';
    }

    document.documentElement.classList.toggle('lock-all', true);
    let swiperBox = this.querySelector('.swiper-container') || '';
    const slideElements = this.querySelectorAll('.swiper-slide');
    const totalSlides = slideElements.length;
    let initialIndex = parseInt(item.getAttribute('data-index'), 10) || 0;

    initialIndex = Math.min(Math.max(initialIndex, 0), Math.max(totalSlides - 1, 0));

    let videoPayList = Array.from(this.querySelectorAll('.tiktok-video')) || [];
    if (initialIndex === 0 && videoPayList[0]) {
      videoPayList[0].play().catch((e) => console.log('Play failed:', e));
    }

    if (swiperBox) {
      this.swiperScrollAnimation(swiperBox, initialIndex);
    }
  }

  swiperScrollAnimation(swiperBox, initialIndex) {
    let swiper = new Swiper(`#${swiperBox.id}`, {
      direction: 'vertical',
      mousewheel: true,
      keyboard: true,
      simulateTouch: true,
      resistanceRatio: 0,
      initialSlide: initialIndex,
      speed: 500,
      effect: 'creative',
      creativeEffect: {
        prev: {
          shadow: true,
          translate: [0, '-100%', 0],
        },
        next: {
          translate: [0, '100%', 0],
        },
      },
      on: {
        slideChange: function () {
          const currentSlide = this.slides[this.activeIndex];
          const prevSlide = this.slides[this.previousIndex];
          const prevVideo = prevSlide?.querySelector('video');
          if (prevVideo) {
            prevVideo.pause();
          }

          const currentVideo = currentSlide?.querySelector('video');
          if (currentVideo) {
            currentVideo.currentTime = 0;
            currentVideo.play().catch(() => {});
          }
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    return swiper;
  }

  updateArrows(box, leftBtn, rightBtn, allArrow, item) {
    const step = item.offsetWidth * 2 + 16;
    const needsArrows = box.scrollWidth > box.offsetWidth;

    if (allArrow) {
      allArrow.style.display = needsArrows ? 'flex' : 'none';
    }

    if (leftBtn) {
      leftBtn.onclick = () => box.scrollBy({ left: -step, behavior: 'smooth' });
    }

    if (rightBtn) {
      rightBtn.onclick = () => box.scrollBy({ left: step, behavior: 'smooth' });
    }
  }
};

if (!window.customElements.get('influencer-list-new')) {
  window.customElements.define('influencer-list-new', influencerListNew);
}

const bootstrapInfluencerListNew = () => {
  document.querySelectorAll('influencer-list-new').forEach((instance) => {
    initializeInfluencerListNewInstance(instance);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapInfluencerListNew, { once: true });
} else {
  bootstrapInfluencerListNew();
}
